'use strict';

import React from 'react';
import classNames from 'classnames';

import FocusTrap from 'focus-trap-react';

const uploadErrors = props => (
  <FocusTrap active={props.isOpen}>
    <div className={classNames('backdrop', props.isOpen ? 'd-flex' : 'd-none')}>
      <div className="upload-errors bg-white flex-column">
        <button
          type="button"
          className="close p-0"
          aria-label="Close"
          onClick={() => props.onClose()}
        >
          <i className="fas fa-times" />
        </button>
        <div className="p-4 pr-2 h-100 d-flex flex-column">
          <h2 className="title ml-0 d-flex">
            <span className="fa-stack text-dark">
              <i className="far fa-circle fa-stack-2x" />
              <i className="fas fa-exclamation fa-stack-1x" />
            </span>
            Upload Error
          </h2>
          <p className="content py-2">
            {props.errors.length} of your files cannot be uploaded and will not be added to your project:
          </p>
          <ul className="errors-list flex-grow-1 list-unstyled p-1">
            {
              props.errors.map((error, i) => (
                <li key={i + error.name} className="content m-0">
                  {error.name}
                </li>
              ))
            }
          </ul>
          <button
            type="button"
            aria-label="Remove all"
            className="btn btn-primary mt-auto ml-auto font-weight-bold px-0"
            onClick={props.onRemoveAllClick}
          >
            Remove all
          </button>
        </div>
      </div>
    </div>
  </FocusTrap>
);

export default uploadErrors;
